import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { StaffRouteContentSkeleton } from '../../shared/ui/StaffRouteContentSkeleton';
import { AppShell } from './AppShell';

export function AdminLayout() {
  return (
    <AppShell>
      <Suspense fallback={<StaffRouteContentSkeleton />}>
        <Outlet />
      </Suspense>
    </AppShell>
  );
}
